import React from 'react';
import Bonus from 'gatsby-core-theme/src/components/molecules/bonus/template-one'

export default function index(props) {
  return (
    <Bonus {...props} tncFixed width={64} height={64} />
  )
}
